/**
 * nav-live(2026-10-24) — LIVE 표지 한 벌(빨간 알약 + 흰 점 맥박 + 「LIVE」). 상세 하단 바·도크·지역 문서의 «실시간 소통» 버튼과
 * 헤더 방문자 카운터가 같은 모양을 쓴다(두 벌로 적으면 한쪽만 바뀐다).
 *
 * 왜: Node 요청 — 「카톡방 입장」 대신 「실시간 소통」 + 눈에 띄는 라이브 표시.
 * ⛔ 훅 없음 · 서버/클라이언트 어디서나 렌더 · 방문자 무관(같은 URL = 같은 HTML).
 * ⛔ 맥박은 CSS 만(live.css). prefers-reduced-motion 이면 애니메이션 0(정지 점).
 * 표지는 aria-hidden — 스크린리더는 버튼 문구(「실시간 소통」)만 읽는다.
 */
import React from 'react'; // vitest(클래식 JSX) 렌더 검증용
import './live.css';

/** 카톡방 CTA 공용 문구(Node 2026-10-24 — 「카톡방 입장」 → 「실시간 소통」). */
export const TALK_LIVE_LABEL = '실시간 소통';

export function LiveBadge({ className }: { className?: string }) {
  return (
    <span className={className ? `kd-lv ${className}` : 'kd-lv'} aria-hidden="true" data-live-badge="">
      <span className="kd-lv__dot" />
      <span className="kd-lv__t">LIVE</span>
    </span>
  );
}

/**
 * 「● 실시간 소통 [LIVE]」 — 카톡방 버튼 안쪽 내용(live-v2 2026-10-25 · Node 「라이브 표현 구림」).
 *   빨간 사각 블록을 글자 앞에 박던 것 → 맥박 점 + 문구 + 버튼 모서리 «LIVE» 꼬리표(알림 배지 꼴).
 *   꼬리표는 버튼(호스트)에 position:relative 가 있어야 제자리 — 호출부 a 에 LIVE_HOST_CLASS 를 붙인다.
 */
export const LIVE_HOST_CLASS = 'kd-lv-host';
export function TalkLiveLabel({ label = TALK_LIVE_LABEL }: { label?: string }) {
  return (
    <>
      <span className="kd-lv-pulse" aria-hidden="true" data-live-badge=""><span className="kd-lv__dot" /></span>
      <span className="kd-lv-label">{label}</span>
      <span className="kd-lv-tag" aria-hidden="true">LIVE</span>
    </>
  );
}

export default LiveBadge;
